export const API_URL = process.env.API_URL || 'https://draw.omagad.tech/api';
export const WS_URL = process.env.WS_URL || 'wss://draw-ws.omagad.tech';
export const APP_URL = process.env.APP_URL || 'https://draw.omagad.tech';
